export interface ChevronRightIconProps {
  size: 'small' | 'large'
}

export const ChevronRightIcon = ({ size }: ChevronRightIconProps) =>
  size === 'small' ? (
    <svg
      width="12"
      height="22"
      viewBox="0 0 12 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>chevron-right-small</title>
      <path
        d="M1.5 1.66658L10.8333 10.9999L1.5 20.3333"
        stroke="#5234B6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg
      width="20"
      height="36"
      viewBox="0 0 20 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>chevron-right-large</title>
      <path
        d="M1.75 1.08329L18.6667 18L1.75 34.9166"
        stroke="#5234B6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
